<template>
  <CButton
    :class="`${
      size === 'sm' ? 'd-flex align-items-center' : 'mz-button v2-mz-btn'
    }`"
    color="primary"
    :to="to"
    :size="size"
  >
    {{$t('Add')}}
    <i
      class="ml-2 mz-icon icon-add"
      :class="{ 'w-100 h-100': size === 'sm' }"
    />
  </CButton>
</template>

<script>
export default {
  name: "AddButton",
  props: {
    to: {
      type: [Object, String],
      default: "",
    },
    size: {
      type: String,
      validator: (value) => ["", "sm", "lg"].includes(value),
      default: "",
    },
  },
};
</script>
